import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../i18n";

const PORTRAIT = "https://customer-assets.emergentagent.com/job_exclusive-pm/artifacts/er3ywcms_20251230_104308000_iOS.jpg";

export default function About() {
  const { t } = useLang();
  return (
    <div data-testid="about-page" className="bg-[#0F0F0F]">
      <section className="pt-36 md:pt-44 pb-20">
        <div className="max-w-[1200px] mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-12 gap-12 items-center">
          <div className="md:col-span-5 order-2 md:order-1">
            <div className="relative aspect-[4/5] overflow-hidden zoom-wrap">
              <img src={PORTRAIT} alt="Roland Azar" className="zoom-img w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
            </div>
          </div>
          <div className="md:col-span-7 md:pl-10 order-1 md:order-2">
            <div className="eyebrow mb-4">{t.about.eyebrow}</div>
            <h1 className="font-serif text-5xl md:text-7xl text-[#F5F5F0] tracking-tight leading-[0.95] mb-4">{t.about.title}</h1>
            <div className="text-[#D4AF37] text-sm tracking-[0.15em] uppercase mb-10">{t.about.role}</div>
            <span className="gold-line mb-8"></span>
            <p className="text-white/70 leading-relaxed text-lg mb-6">{t.about.body1}</p>
            <p className="text-white/70 leading-relaxed text-lg">{t.about.body2}</p>
          </div>
        </div>
      </section>

      {/* STATS */}
      <section className="py-20 md:py-28 bg-[#0B0B0B] border-y border-white/5">
        <div className="max-w-[1200px] mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-3 gap-12 text-center md:text-left items-end">
          {t.about.stats.map((s, i) => {
            const isNumeric = /^[\d+%]/.test(s.n);
            return (
              <div key={i} data-testid={`stat-${i}`}>
                <div className="flex items-baseline min-h-[72px] md:min-h-[88px] mb-3 justify-center md:justify-start">
                  <div className={`font-serif text-[#D4AF37] leading-none ${isNumeric ? "text-6xl md:text-7xl" : "text-5xl md:text-6xl"}`}>{s.n}</div>
                </div>
                <div className="text-[0.7rem] uppercase tracking-[0.25em] text-white/50">{s.l}</div>
              </div>
            );
          })}
        </div>
      </section>

      <section className="py-24 md:py-32 text-center">
        <div className="max-w-3xl mx-auto px-6">
          <Link to="/contact" className="btn-gold" data-testid="about-cta">{t.cta.private_consultation}</Link>
        </div>
      </section>
    </div>
  );
}
